/** Jail: a cold cell. A lone erhu over a dark drone, low qin notes, water dripping somewhere. */
import { drone } from '../compose';
import { registerTrack } from '../registry';

const A_ERHU = `@mp 3,/- 5,_ 6,_ 1 | 6,\\--- | 5,_ 6,_ 1_ 2_ 3- | 2_ 1_ 6,- 0 ; |
  3/- 2_ 1_ 6, | 1- 6,_ 5,_ 3, | 5,_ 6,_ 5,_ 3,_ 5,- | 3,~---`;
const A_QIN = `@mp 3,,--- | 0--- | 6,,--- | 0--- | 3,,--- | 0--- | 2,,--- | 3,,~---`;

const B_ERHU = `@mf 6/- 5_ 3_ 2 | 3\\--- | 5_ 6_ 1'_ 6_ 5 3 | 2~-- 0 ; |
  1. 2_ 3 5 | 3_ 2_ 1_ 6,_ 1- | 2_ 1_ 6,_ 5,_ 6, 5, | 3,---`;
const B_QIN = `@mp 6,,--- | 0--- | 5,,--- | 0--- | 1,--- | 6,,--- | 2,,--- | 3,,~---`;

const DRIP = `0- rp 0 | 0--- | 0 rp 0- | 0--- | 0- 0 rp | 0--- | rp 0-- | 0---`;

registerTrack({
  id: 'jail',
  order: 18,
  title: 'ห้องขังเย็นเยียบ',
  mood: 'หม่นหมอง โดดเดี่ยว สำนึกผิด',
  use: 'ขณะถูกขังคุก',
  key: 'F',
  mode: 'jue',
  bpm: 52,
  meter: 4,
  seed: 1818,
  humanize: 0.6,
  parts: {
    erhu: { inst: 'erhu', pan: -0.1, reverb: 0.5 },
    qin: { inst: 'qin', gain: 0.8, pan: 0.15, reverb: 0.45 },
    pad: { inst: 'pad', gain: 0.8, reverb: 0.5 },
    drip: { inst: 'perc', gain: 0.1, pan: 0.4, reverb: 0.8 },
  },
  sections: {
    A: {
      bars: 8,
      parts: { erhu: A_ERHU, qin: A_QIN, pad: drone(`3,, 3,, 3,, 3,, 3,, 3,, 2,, 3,,`, 4), drip: DRIP },
    },
    B: {
      bars: 8,
      parts: { erhu: B_ERHU, qin: B_QIN, pad: drone(`6,, 6,, 5,, 5,, 1, 6,, 2,, 3,,`, 4), drip: DRIP },
    },
  },
  form: ['A', 'B', 'A'],
  loop: true,
});
